import React from 'react'
import Code from './blogPostComponents/Code';
import { navbarHeight } from '../App';
import { useMediaQuery } from '@material-ui/core';
import { FaArrowDown } from 'react-icons/fa';
import { Link as ScrollLink } from 'react-scroll';


const ContentSection = ( {children, sectionTitle, className, style, maxHeight='10000px', ...props} ) => {

  const isMobile = useMediaQuery('(max-width: 460px)');
  // const isTablet = useMediaQuery('(max-width: 768px)');

  return (
    // style={{height: `min(calc(130vh - ${navbarHeight}), ${maxHeight})`, ...style}}
    <div className={`relative max-w-3xl ${className}`} {...props}>
      <span className='absolute left-0 text-9xl sm:text-12xl md:text-15xl text-light-accent dark:text-dark-accent font-bold font-outline-2'>
        {sectionTitle}
      </span>
      <div className='absolute top-24 sm:top-48 md:top-60 left-0 right-0 flex flex-col justify-start items-center'>
        {children}
      </div>
      {/* <div className='absolute bottom-16 -right-52 flex w-full mx-auto justify-end animate-pulse text-4xl mt-10 sm:mt-20'>
        <ScrollLink to="work" smooth={true} duration={500} spy={true} exact="true">
          <FaArrowDown className='h-14 w-7 px-1 border-2 border-black rounded-3xl cursor-pointer'/>
        </ScrollLink>
      </div> */}
    </div>
  )
}

export default ContentSection